export default "__VITE_ASSET__CMDmhPeH__"